export default __webpack_public_path__ + "static/media/FICHA TÉCNICA - MANGA KENT.5cda73db.pdf";